import { createContext } from 'react';

import { ElectronicClientRecordHook } from '../hooks/electronic-client-record-hook';

const ElectronicClientRecordProviderContext = createContext({} as ElectronicClientRecordHook);

export default ElectronicClientRecordProviderContext;
